export default {
    courseIds: [],

    progressMapping: null,
    courses: {},
    stepGroups: {},
    steps: {},
    memos: {},
    scenarios: {},
    systems: [],

    stepGroupQuizStates: {},

    otherStuff: {
        lastStepId: null,
        lastJourneyId: null
    }
};
